/*
    Extracts www.google.com from:
    ✅ https://www.google.com
    ✅ http://www.google.com
    ✅ http://www.google.com?asd=q
    ✅ http://www.google.com#swag
    ✅ http://www.google123.co.com
    ✅ http://google.com/asd?q=true
    🛑 www.google.com
    🛑 htt://www.google.com
    🛑 ://www.google.com

    To experiment: https://www.regextester.com
*/
const baseUrlRegex = /^(https?:\/\/[a-z0-9.]*)(\/|\?|#|$)/;
const baseUrlWithoutProtocolRegex = /^https?:\/\/([a-z0-9.]*)(\/|\?|#|$)/;

export const MBLinkPreviewUtil = {
  baseUrlFromUrl(url: string): string | null {
    const match = url.match(baseUrlRegex);
    if (!!match) {
      return match[1];
    }
    return null;
  },
  baseUrlWithoutProtocolFromUrl(url: string): string | null {
    const match = url.match(baseUrlWithoutProtocolRegex);
    if (!!match) {
      return match[1];
    }
    return null;
  },
};
